import { createMuiTheme } from '@material-ui/core/styles';
import base from './base';
// example
var theme = createMuiTheme(base, {
    overrides: {
        MuiTypography: {
            colorPrimary: {
                color: '#ffae00',
            },
        },
    },
});
export default theme;
//# sourceMappingURL=zabota.js.map